import PageCollection from '../../base/collections/page';

import { PaymentItem } from '../models/payment_item';

module.exports = PageCollection.extend({
  model: PaymentItem,

  toggleHidden() {
    const isActiveFlag = this.search_params.is_active;

    this.search_params.is_active = isActiveFlag ? undefined : 'True';
    this.fetch();
  }
});



// WEBPACK FOOTER //
// ./epayment/collections/paymentitem.js